import { config } from "../lib/api.js";
import { PageHeader } from "../components/PageHeader.jsx";

export function Settings() {
  return (
    <>
      <PageHeader title="Settings" subtitle="Connection details and operational tips." />
      <div className="card mb-4">
        <div className="font-medium mb-2">Backend connection</div>
        <div className="text-sm space-y-1">
          <div><span className="subtle">API base: </span>{config.base || <span className="text-rose-400">not set</span>}</div>
          <div><span className="subtle">Token configured: </span>{config.hasToken ? "yes" : <span className="text-rose-400">no</span>}</div>
        </div>
        <div className="text-xs subtle mt-3">
          Set <code className="bg-white/5 px-1 rounded">VITE_API_BASE</code> and <code className="bg-white/5 px-1 rounded">VITE_API_TOKEN</code>
          {" "}in <code className="bg-white/5 px-1 rounded">dashboard/.env.local</code> and rebuild. The token must equal the Worker secret <code className="bg-white/5 px-1 rounded">DASHBOARD_API_KEY</code>.
        </div>
      </div>

      <div className="card mb-4">
        <div className="font-medium mb-2">Extension setup</div>
        <ol className="list-decimal list-inside text-sm space-y-1">
          <li>Run <code className="bg-white/5 px-1 rounded">pnpm --filter extension build</code></li>
          <li>Open <code className="bg-white/5 px-1 rounded">chrome://extensions</code>, enable Developer Mode</li>
          <li>Click &quot;Load unpacked&quot; and select <code className="bg-white/5 px-1 rounded">extension/dist</code></li>
          <li>Open the extension Options page and paste your Worker URL + the same HMAC secret</li>
          <li>Visit linkedin.com — posts on screen will be captured automatically</li>
        </ol>
      </div>

      <div className="card">
        <div className="font-medium mb-2">Operational tips</div>
        <ul className="list-disc list-inside text-sm subtle space-y-1">
          <li>Throttle: the extension waits 5s between scrapes to mimic human reading.</li>
          <li>If LinkedIn updates its DOM, edit <code className="bg-white/5 px-1 rounded">extension/src/scrapers/postNode.js</code> only.</li>
          <li>AI calls are capped at 60/hr. Cron at 09:00 UTC backfills embeddings nightly.</li>
        </ul>
      </div>
    </>
  );
}
